import { ChevronRight } from "lucide-react";
import { useLocation, Link } from "react-router-dom";

const SectionHeader = ({ title, showBreadcrumbs = false }) => {
  const location = useLocation();

  const breadcrumbs = location.pathname
    .split("/")
    .filter(Boolean)
    .map((part, index, arr) => ({
      label: part.charAt(0).toUpperCase() + part.slice(1),
      href: `/${arr.slice(0, index + 1).join("/")}`,
    }));

  return (
    <div className="mb-6">
      {showBreadcrumbs && breadcrumbs.length > 0 && (
        <nav className="flex items-center space-x-2 text-sm text-gray-500 mb-2">
          {breadcrumbs.map((item, index) => (
            <span key={index} className="flex items-center">
              {index < breadcrumbs.length - 1 ? (
                <Link
                  to={item.href}
                  className="hover:text-gray-700 hover:underline transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="font-semibold text-gray-800">{item.label}</span>
              )}
              {index < breadcrumbs.length - 1 && (
                <ChevronRight className="mx-1" size={16} />
              )}
            </span>
          ))}
        </nav>
      )}
      <h1 className="text-2xl font-bold text-gray-800 tracking-tight">
        {title}
      </h1>
    </div>
  );
};

export default SectionHeader;
